import { render, staticRenderFns } from "./FileGallery.vue?vue&type=template&id=f2098f1c&scoped=true&"
import script from "./FileGallery.vue?vue&type=script&lang=ts&"
export * from "./FileGallery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2098f1c",
  null
  
)

export default component.exports